

































import Vue from 'vue';
import { ResourceLoader } from 'mycorems-app-shared';
import isGranted from '../auth/isGranted';
import { PaymentMethod } from '../types';
import PaymentMethodItem from './PaymentMethodItem.vue';
import repository from './payment-method-repository';
import MarkAsPrimaryBtn from './MarkAsPrimaryBtn.vue';
import DeletePaymentMethodBtn from './DeletePaymentMethodBtn.vue';

interface Data {
  items: PaymentMethod[],
  task: Promise<PaymentMethod[]>|null,
}

export default Vue.extend({
  components: {
    ResourceLoader,
    PaymentMethodItem,
    MarkAsPrimaryBtn,
    DeletePaymentMethodBtn,
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      items: [],
      task: null,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },

  methods: {
    load() {
      this.task = repository.findAll(this.customerId);
      this.task.then((items: PaymentMethod[]) => {
        this.items = items;
      });
    },
    add(item: PaymentMethod) {
      if (item.isPrimary) {
        this.markPrimaryAsSecondary();
      }
      this.items.push(item);
    },
    remove(item: PaymentMethod) {
      const index = this.items.findIndex(i => i.id === item.id);
      if (index >= 0) {
        this.items.splice(index, 1);
      }
    },
    markAsPrimary(item: PaymentMethod) {
      this.markPrimaryAsSecondary();
      item.isPrimary = true;
    },
    markPrimaryAsSecondary() {
      const primary = this.items.find(i => i.isPrimary);
      if (primary) {
        primary.isPrimary = false;
      }
    },
    isGranted,
  },
});
